import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import newBox from '../views/newBox.vue'
import contact from '../views/contact.vue'
import About from '../views/About.vue'
import Footer from '../views/Footer.vue'
import policy from '../views/policy.vue'
import vipBox from '../views/vipBox.vue'
import signUp from '../views/signUp.vue'
import newDetails from '../views/newDetails.vue'
import zhaogong from '../views/zhaogong.vue'
import zhaogongDetails from '../views/zhaogongDetails.vue'



Vue.use(VueRouter)
const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
	}, {
		path: '/contact',
		name: 'contact',
		component: contact,
	}, {
		path: '/newBox',
		name: 'newBox',
		component: newBox
	}, {
		path: '/About',
		name: 'About',
		component: About
	}, {
		path: '/Footer',
		name: 'Footer',
		component: Footer
	}, {
		path: '/policy',
		name: 'policy',
		component: policy
	}, {
		path: '/vipBox',
		name: 'vipBox',
		component: vipBox
	}, {
		path: '/signUp',
		name: 'signUp',
		component: signUp
	}, {
		path: '/newDetails',
		name: 'newDetails',
		component: newDetails
	}, {
		path: '/zhaogong',
		name: 'zhaogong',
		component: zhaogong
	}, {
		path: '/zhaogongDetails',
		name: 'zhaogongDetails',
		component: zhaogongDetails
	}

]

const router = new VueRouter({
	mode: 'hash',
	// base: process.env.BASE_URL,
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 每次路由跳转时，滚动到页面顶部
		return { x: 0, y: 0 };
	}
})



export default router
